import { createAction } from "redux-actions";
import createAsyncActions from "../../../utilities/createAsyncActions";
import { CLEAR_OFFER_IDS, GET_OFFER_IDS } from "../types/getOfferIdsTypes";

export const {
  getOfferIds,
  getOfferIdsPending,
  getOfferIdsFulfilled,
  getOfferIdsRejected,
} = createAsyncActions(GET_OFFER_IDS, "getOfferIds");

export const clearOfferIds = createAction(CLEAR_OFFER_IDS);



// WEBPACK FOOTER //
// ./src/features/score-card/actions/getOfferIdsAction.js